module.exports = __webpack_public_path__ + "media/3.5004c457.mp3";